






























































import { Component, Vue, Prop } from 'vue-property-decorator';
import NfreshDeliveryResponse from "./NfreshDeliveryResponse.vue";
import VueError from '@/components/VueError.vue';
import { Delivery } from '@/types/core-push';
import TimestampAgo from '@/components/TimestampAgo.vue';
import MobileFriendlyRow from '@/components/MobileFriendlyRow.vue';
import { Column } from '../../types/core';

@Component({
  components:{
    MobileFriendlyRow,
    NfreshDeliveryResponse,
    VueError,
    TimestampAgo
  }
})

export default class DeliveryRow extends Vue {

  @Prop({ default: {}, type: Object}) delivery!:Delivery;
  @Prop({ default: 0,  type: Number}) index!: number;
  @Prop({ default: '', type: String}) error: string|undefined;

  cols:Column[] = [
    { colKey: 'startedTs', colName: 'start time', colStyle:{'flex-grow':1}},
    { colKey: 'result', colName: 'result', colStyle: {width: '25%'}}
  ];

}

